var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLootboxIconCount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.09091L13 0H1L0 1.09091V4.77273L0.90875 6L0 7.22727V10.9091L1 12H13L14 10.9091V7.22727L13.0913 6L14 4.77273V1.09091ZM1 1.54261L1.41406 1.09091H12.5856L12.9997 1.54261V4.38716L12.2094 5.45455H9.62469L8.62469 3.81818H5.37469L4.37469 5.45455H1.79031L1 4.38716V1.54261ZM8.75656 6L8.09 7.09091H5.91031L5.24375 6L5.91031 4.90909H8.09L8.75656 6ZM1.41406 10.9091L1 10.4574V7.61284L1.79031 6.54545H2.625V10.9091H1.41437H1.41406ZM3.62469 10.9091V6.54545H4.37469L5.37469 8.18182H8.62469L9.62469 6.54545H10.3747V10.9091H3.625H3.62469ZM12.9997 10.4574L12.5856 10.9091H11.3747V6.54545H12.2094L12.9997 7.61284V10.4574Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLootboxIconCount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lootbox-icon-count.e255d11256541f241689ce130e610e28.svg";